// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onglet "Notification et signature" ACHETEUR-BC. Previsualisation PDF du bon de commande signe
   (iframe) + apercu du mail de notification. Palette fermee (headers #595959, orange #f97316, texte
   #374151).

   ATTENTION — l'en-tete disait "copie ISOLEE des classes de la vue presta". C'est FAUX : les memes
   \`.bc-notif__*\` sont declarees dans SuiviDeCommandeBCV2/components/CommandeNotification.css, et en
   CRA tout le CSS est global et bundle. Les deux jeux s'appliquent donc aux DEUX vues, et a
   specificite egale c'est le dernier charge qui gagne. Ces regles doivent rester IDENTIQUES des deux
   cotes, sinon la valeur affichee depend de l'ordre d'import — pas d'une decision. */

/* Le rappel d'etat du bas porte \`no-print\`. Cette classe est DEJA effective sur le chemin
   d'impression du projet : PrintButton clone le contenu dans une fenetre a part et y injecte
   \`@media print { .no-print, .no-print * { display: none !important } }\`. La regle ci-dessous couvre
   l'AUTRE chemin, l'impression native du navigateur (Ctrl+P sur la page), ou seules les feuilles de
   l'app s'appliquent. SCOPEE a \`.bc-notif\` : une regle globale changerait le rendu imprime du reste
   de l'app, ce qui n'est pas demande. A l'impression, l'etat reste en tete ; le repeter ne servirait
   qu'a consommer du papier. */
@media print {
  .bc-notif .no-print {
    display: none;
  }
}

.bc-notif__preview {
  margin-bottom: 1.5rem;
}

/* Cadre du document. Calque sur \`.opms__marche-pdf\` du MS (copie ISOLEE, classes prefixees BC). */
.bc-notif__pdf {
  margin-top: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: #f5f5f5;
}

/* Preview a 3/4 de la largeur, comme le MS (\`.opms__marche-pdf--narrow\`) : le quart restant est du
   VIDE, pas une colonne — il laisse de quoi scroller la page autour du document. */
.bc-notif__pdf--narrow {
  width: 75%;
}

.bc-notif__iframe {
  width: 100%;
  height: 600px;
  border: none;
  background: #fff;
}

.bc-notif__preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24rem;
  padding: 2rem;
  border: 1px dashed #d1d5db;
  border-radius: 0.75rem;
  background: rgba(215, 217, 217, 0.15);
  color: #6b7280;
  text-align: center;
  line-height: 1.5;
}

.bc-notif__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.6rem;
}

/* Icone PDF en BLANC sur le bouton orange : \`pdf.svg\` porte un \`fill="#2C3948"\` en dur, donc l'icone
   sortait sombre sur fond orange. On cible \`path\` ET l'element : le fill CSS l'emporte sur l'attribut
   de presentation du SVG, mais seulement s'il frappe le noeud qui le porte. */
.bc-notif__actions .button.primary .button-icon svg,
.bc-notif__actions .button.primary .button-icon svg path {
  fill: #fff;
}

/* Section "Information au candidat" : tableau (Prestataire | Mail | Contenu | Notification), calque
   sur "Information aux candidats" du MS (.opms__candidats*), copie ISOLEE (aucun partage cross-module). */
.bc-notif__candidats {
  margin-bottom: 1.5rem;
}

.bc-notif__candidats-row {
  display: grid;
  grid-template-columns: 1.4fr 1.6fr 1.4fr 1.6fr;
  gap: 1rem;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid #eaeaea;
  font-size: 1.3rem;
  color: #2c3948;
}

.bc-notif__candidats-head {
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 2px solid #d7d9d9;
}

.bc-notif__candidats-nom {
  font-weight: 600;
}

.bc-notif__candidats-mail {
  word-break: break-all;
}

.bc-notif__candidats-link {
  background: none;
  border: none;
  padding: 0;
  color: #f97316;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

/* Modale d'apercu du mail : style calque sur la modale "Voir le message" du MS (.opms__marche-modal*)
   -> overlay centre, boite max 80vw/90vh scrollable, barre sticky blanche, titre fonce. */
.bc-notif__modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.bc-notif__modal {
  position: relative;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
}

.bc-notif__modal-bar {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.bc-notif__modal-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
}

.bc-notif__modal-actions {
  display: flex;
  gap: 0.6rem;
}

/* En-tete du bloc NON-RETENUS : il ouvre un second tableau sous celui du retenu, d'ou l'espace au
   dessus. Leur mail n'est pas la notification du bon de commande mais l'expiration (Brevo 13) —
   les deux blocs doivent se lire comme distincts. */
.bc-notif__candidats-head--non-retenus {
  margin-top: 2rem;
}

/* Les marges verticales de freres adjacents FUSIONNENT dans un bloc : \`.bc-notif__preview\`
   (margin-bottom 1.5rem) et \`.bc-notif__actions\` (margin-top 1.6rem) ne produisaient que 1.6rem
   au lieu de 3.1rem. Un contexte flex supprime cette fusion — les marges s'additionnent alors comme
   la chaine d'espacement le prevoit. \`column\` + etirement par defaut : le flux vertical est
   inchange pour les autres enfants de la section.
   REGLE DUPLIQUEE A L'IDENTIQUE dans les deux feuilles BC (cf. avertissement en tete). */
.bc-notif .section-content {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCV2/components/OperationNotification.css"],"names":[],"mappings":"AAAA;;;;;;;;qFAQqF;;AAErF;;;;;;8BAM8B;AAC9B;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kGAAkG;AAClG;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;mFACmF;AACnF;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;8EAE8E;AAC9E;;EAEE,UAAU;AACZ;;AAEA;0GAC0G;AAC1G;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;0FAC0F;AAC1F;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;oDAEoD;AACpD;EACE,gBAAgB;AAClB;;AAEA;;;;;yFAKyF;AACzF;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* Onglet \"Notification et signature\" ACHETEUR-BC. Previsualisation PDF du bon de commande signe\n   (iframe) + apercu du mail de notification. Palette fermee (headers #595959, orange #f97316, texte\n   #374151).\n\n   ATTENTION — l'en-tete disait \"copie ISOLEE des classes de la vue presta\". C'est FAUX : les memes\n   `.bc-notif__*` sont declarees dans SuiviDeCommandeBCV2/components/CommandeNotification.css, et en\n   CRA tout le CSS est global et bundle. Les deux jeux s'appliquent donc aux DEUX vues, et a\n   specificite egale c'est le dernier charge qui gagne. Ces regles doivent rester IDENTIQUES des deux\n   cotes, sinon la valeur affichee depend de l'ordre d'import — pas d'une decision. */\n\n/* Le rappel d'etat du bas porte `no-print`. Cette classe est DEJA effective sur le chemin\n   d'impression du projet : PrintButton clone le contenu dans une fenetre a part et y injecte\n   `@media print { .no-print, .no-print * { display: none !important } }`. La regle ci-dessous couvre\n   l'AUTRE chemin, l'impression native du navigateur (Ctrl+P sur la page), ou seules les feuilles de\n   l'app s'appliquent. SCOPEE a `.bc-notif` : une regle globale changerait le rendu imprime du reste\n   de l'app, ce qui n'est pas demande. A l'impression, l'etat reste en tete ; le repeter ne servirait\n   qu'a consommer du papier. */\n@media print {\n  .bc-notif .no-print {\n    display: none;\n  }\n}\n\n.bc-notif__preview {\n  margin-bottom: 1.5rem;\n}\n\n/* Cadre du document. Calque sur `.opms__marche-pdf` du MS (copie ISOLEE, classes prefixees BC). */\n.bc-notif__pdf {\n  margin-top: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  background-color: #f5f5f5;\n}\n\n/* Preview a 3/4 de la largeur, comme le MS (`.opms__marche-pdf--narrow`) : le quart restant est du\n   VIDE, pas une colonne — il laisse de quoi scroller la page autour du document. */\n.bc-notif__pdf--narrow {\n  width: 75%;\n}\n\n.bc-notif__iframe {\n  width: 100%;\n  height: 600px;\n  border: none;\n  background: #fff;\n}\n\n.bc-notif__preview-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24rem;\n  padding: 2rem;\n  border: 1px dashed #d1d5db;\n  border-radius: 0.75rem;\n  background: rgba(215, 217, 217, 0.15);\n  color: #6b7280;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.bc-notif__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.6rem;\n}\n\n/* Icone PDF en BLANC sur le bouton orange : `pdf.svg` porte un `fill=\"#2C3948\"` en dur, donc l'icone\n   sortait sombre sur fond orange. On cible `path` ET l'element : le fill CSS l'emporte sur l'attribut\n   de presentation du SVG, mais seulement s'il frappe le noeud qui le porte. */\n.bc-notif__actions .button.primary .button-icon svg,\n.bc-notif__actions .button.primary .button-icon svg path {\n  fill: #fff;\n}\n\n/* Section \"Information au candidat\" : tableau (Prestataire | Mail | Contenu | Notification), calque\n   sur \"Information aux candidats\" du MS (.opms__candidats*), copie ISOLEE (aucun partage cross-module). */\n.bc-notif__candidats {\n  margin-bottom: 1.5rem;\n}\n\n.bc-notif__candidats-row {\n  display: grid;\n  grid-template-columns: 1.4fr 1.6fr 1.4fr 1.6fr;\n  gap: 1rem;\n  align-items: center;\n  padding: 0.8rem 0;\n  border-bottom: 1px solid #eaeaea;\n  font-size: 1.3rem;\n  color: #2c3948;\n}\n\n.bc-notif__candidats-head {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  border-bottom: 2px solid #d7d9d9;\n}\n\n.bc-notif__candidats-nom {\n  font-weight: 600;\n}\n\n.bc-notif__candidats-mail {\n  word-break: break-all;\n}\n\n.bc-notif__candidats-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #f97316;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Modale d'apercu du mail : style calque sur la modale \"Voir le message\" du MS (.opms__marche-modal*)\n   -> overlay centre, boite max 80vw/90vh scrollable, barre sticky blanche, titre fonce. */\n.bc-notif__modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.bc-notif__modal {\n  position: relative;\n  background: #fff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 80vw;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.bc-notif__modal-bar {\n  position: sticky;\n  top: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n}\n\n.bc-notif__modal-title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n.bc-notif__modal-actions {\n  display: flex;\n  gap: 0.6rem;\n}\n\n/* En-tete du bloc NON-RETENUS : il ouvre un second tableau sous celui du retenu, d'ou l'espace au\n   dessus. Leur mail n'est pas la notification du bon de commande mais l'expiration (Brevo 13) —\n   les deux blocs doivent se lire comme distincts. */\n.bc-notif__candidats-head--non-retenus {\n  margin-top: 2rem;\n}\n\n/* Les marges verticales de freres adjacents FUSIONNENT dans un bloc : `.bc-notif__preview`\n   (margin-bottom 1.5rem) et `.bc-notif__actions` (margin-top 1.6rem) ne produisaient que 1.6rem\n   au lieu de 3.1rem. Un contexte flex supprime cette fusion — les marges s'additionnent alors comme\n   la chaine d'espacement le prevoit. `column` + etirement par defaut : le flux vertical est\n   inchange pour les autres enfants de la section.\n   REGLE DUPLIQUEE A L'IDENTIQUE dans les deux feuilles BC (cf. avertissement en tete). */\n.bc-notif .section-content {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
